import React from "react";
import header from "../../images/Consent/SiksikaMarchMadness/header.png";

export class SiksikaMarchMadnessConsent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      agree_to_be_contacted: null,
      parent_name: "",
      child_name: "",
      consent_phone_number: "",
      witness_name: ""
    };
  }

  validateComplete = () => {
    const {
      child_name,
      consent_phone_number,
      witness_name,
      parent_name,
      agree_to_be_contacted
    } = this.state;

    let data = this.state;

    if (
      child_name &&
      consent_phone_number &&
      witness_name &&
      parent_name &&
      agree_to_be_contacted !== null
    ) {
      data.formValid = true;
    } else {
      data.formValid = false;
    }

    this.props.handleChange(data);
  };

  handleChange = event => {
    const { name, value } = event.target;
    if (
      [
        "witness_name",
        "child_name",
        "consent_phone_number",
        "parent_name"
      ].includes(name)
    ) {
      this.setState(
        {
          [name]: value
        },
        this.validateComplete
      );
    } else if (["agree_to_be_contacted"].includes(name)) {
      this.setState(
        {
          [name]: value === "true"
        },
        this.validateComplete
      );
    }
  };

  render() {
    const {
      child_name,
      witness_name,
      consent_phone_number,
      parent_name
    } = this.state;

    const { translate } = this.props;

    return (
      <div>
        <img
          src={header}
          alt="header"
          style={{
            display: "block",
            marginLeft: "auto",
            width: 115
          }}
        />
        <h4>UNIVERSITY OF CALGARY</h4>
        <h4>PARENTAL CONSENT FOR CHILD TO PARTICIPATE IN RESEARCH</h4>
        <h5 className="lead mt-3">TITLE:</h5>
        Siksika March Madness
        <h5 className="lead mt-3">SPONSOR:</h5>
        University of Calgary
        <h5 className="lead mt-3">FUNDER:</h5>
        <p>
          Canadian Institutes of Health Research (CIHR) - You-CAN (Youth
          Concussion Awareness Network) SHRed Concussions (Surveillance in High
          School and Community Sport to Reduce Concussions and their
          Consequences): Canadian Youth Informing Best Practice and Policy in
          the Prevention of Sport-related Concussions
        </p>
        <h5 className="lead mt-3">INVESTIGATORS:</h5>
        <table style={{ borderCollapse: "collapse", marginLeft: "1rem" }}>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Dr. Carolyn Emery
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.5332</td>
          </tr>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Dr. Stephen West
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.5332</td>
          </tr>
        </table>
        <table
          style={{ borderCollapse: "collapse", margin: "1rem 0 1rem 1rem" }}
        >
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Research Coordinators
            </td>
            <td style={{ padding: "4px 10px" }}>
              shred.concussions@ucalgary.ca
            </td>
          </tr>
          <tr>
            <td style={{ width: "300px", padding: "4px 10px" }}>
              Lab Manager - Shane Esau
            </td>
            <td style={{ padding: "4px 10px" }}>403.220.6336</td>
          </tr>
        </table>
        <h5 className="lead mt-3">INTRODUCTION</h5>
        <p>
          Carolyn Emery and her team from the University of Calgary are doing a
          research study.
        </p>
        <p>
          This consent form gives you the basic information about the study and
          what your child will be asked to do. If you want more details about
          anything in this form—or about anything not included—please ask.
          Please read it carefully and make sure you understand everything.
        </p>
        <p>
          Your child was invited to join this study because they are taking part
          in the Siksika March Madness tournament. Taking part in this study is
          completely voluntary.
        </p>
        <h5 className="lead mt-3">WHY IS THIS STUDY BEING DONE?</h5>
        <p>
          The purpose of this research study is to learn more about concussions
          and other injuries in Basketball and ice hockey. We want to:
        </p>
        <ol>
          <li>
            Find out how often concussions and injuries happen, what causes
            them, and what might increase the risk for youth ages 11-19
          </li>
          <li>
            Learn what Siksika Nation needs to help prevent concussions and
            manage them well in the long term.
          </li>
        </ol>
        <h5 className="lead mt-3">ETHICAL CONSIDERATIONS</h5>
        <p>
          Before we do any research with an Indigenous community in Alberta, we
          make a written agreement with the community's leaders. We work
          together with partners like Siksika Nation to make sure the community
          has full control over its data. This means the community decides how
          the information is collected, used, and stored.
        </p>
        <p>
          We have approval from Siksika Health for how we collect and understand
          the data. We also work with Dr. Cheryl Barnabe, a Métis doctor and
          researcher who already has strong partnerships with Siksika Nation.
        </p>
        <p>
          This project supports the Truth and Reconciliation Calls to Action by
          encouraging safe and fair participation in sport. We know that being
          active is important for health, even though it can sometimes lead to
          injuries. We aim to build respectful partnerships and include
          Indigenous leaders and people with lived experience in our research
          team.
        </p>
        <h5 className="lead mt-3">
          HOW MANY PEOPLE WILL TAKE PART IN THIS STUDY?
        </h5>
        <p>
          We will invite up to 1,000 athletes in the Siksika March Madness
          tournament who play ice hockey and/or basketball, which have a high
          risk of concussion.
        </p>
        <h5 className="lead mt-3">
          WHAT WILL HAPPEN IF MY CHILD TAKES PART IN THIS RESEARCH STUDY?{" "}
        </h5>
        <p>
          If you agree to allow your child to participate in this study, we will
          ask them to:
        </p>
        <ol>
          <li>
            Complete baseline questionnaires (e.g., demographics, medical
            history, sport participation).
          </li>
          <li>Participate in injury tracking (e.g. injury report form)</li>
          <li>
            If your child sustains a suspected concussion, the research team
            will support follow-up, which may include an assessment by a health
            care practitioner at Siksika Health or a physician assessment at
            partnering interdisciplinary concussion clinics. As part of follow
            up, a research team member may contact you via phone, text (pinger)
            or email.
          </li>
          <li style={{ textDecoration: "underline", color: "#004377" }}>
            Tournament organizers have agreed to allow video to be taken of ice
            hockey and basketball events. All video will be anonymous to
            individual participants.
          </li>
        </ol>
        <h5 className="lead mt-3">
          HOW LONG WILL MY CHILD BE IN THE RESEARCH STUDY?
        </h5>
        <p>
          Your child will take part in the study for the whole March Madness
          tournament (one month). If they get injured, we will follow up with
          them until the injury has fully healed.
        </p>
        <h5 className="lead mt-3">
          ARE THERE ANY POTENTIAL RISKS OR DISCOMFORTS THAT MY CHILD CAN EXPECT
          FROM THIS STUDY?{" "}
        </h5>
        <p>
          There are very few risks for your child if they choose to participate
          in this study. All the tests and activities we use have been used
          safely with youth in sports before, and no problems have been
          reported.
        </p>
        <h5 className="lead mt-3">
          ARE THERE ANY POTENTIAL BENEFITS TO MY CHILD IF THEY PARTICIPATE?
        </h5>
        <p>
          Your child may or may not get a personal benefit from being in this
          study. However, if your child has a suspected concussion or another
          serious injury, they will get support from experts. This may include
          follow-up care from Siksika Health Services or from sports medicine
          clinics. They may also see doctors and other health-care professionals
          who specialize in sport-related concussions and injuries.
        </p>
        <h5 className="lead mt-3">
          WHAT OTHER CHOICES DOES MY CHILD HAVE IF THEY DO NOT PARTICIPATE?
        </h5>
        <p>
          You can choose not to let your child join the study. If you say no,
          there will be no penalty for you or your child. This decision will not
          affect your child's regular medical care or their ability to play in
          the Siksika March Madness tournament.
        </p>
        <h5 className="lead mt-3">CAN MY CHILD STOP BEING IN THE STUDY?</h5>
        <p>
          Yes. You can decide to stop your child's participation at any time.
          Tell the researchers if you are thinking about stopping or decide to
          stop your child's participation.
        </p>
        <p>
          If you leave the study, you may also request to withdraw your data.
          Your involvement in participating in the March Madness tournament will
          not be affected if you choose not to consent to take part in the
          study. You will be informed if there is new information available
          through this study.
        </p>
        <p>
          You may be contacted in the future and be invited to take part in
          other aligned research studies in which separate consent will be
          sought. Data collected during this study may be combined and reported
          with data from other future studies conducted by this research team.
          We will not share your identifying information with anyone outside the
          research team.
        </p>
        <h5 className="lead mt-3">
          CAN THE RESEARCHERS REMOVE MY CHILD FROM THIS STUDY?
        </h5>
        <p>
          The researchers may stop your child's participation if they think it
          is unsafe or if your child is not following instructions. They or the
          study sponsor can also stop the whole study at any time.
        </p>
        <h5 className="lead mt-3">WITHDRAWAL OF STUDY DATA</h5>
        <p>
          You can contact the research team if you want your child's data
          removed from the study. However, once the data has already been
          analyzed and included in reports, it can no longer be taken out.
        </p>
        <h5 className="lead mt-3">
          WILL MY CHILD BE PAID FOR PARTICIPATING, OR DO I HAVE TO PAY FOR
          ANYTHING?
        </h5>
        <p>
          You/your child will not be paid for their participation in this
          research study. You will not be paid for any out-of-pocket expenses,
          such as parking or transportation fees.
        </p>
        <h5 className="lead mt-3">
          WILL INFORMATION ABOUT MY CHILD'S PARTICIPATION BE KEPT CONFIDENTIAL?
        </h5>
        <p>
          The researchers will work hard to keep your child's personal
          information private. They will protect your child's data as much as
          possible, but there is always a small chance that information could be
          seen by someone who should not see it.
        </p>
        <p>
          All the information we collect will be de-identified, which means your
          child's name will be removed. Only the main researchers, their
          supervised team members, the statistician who analyzes the data, the
          University of Calgary, and the Conjoint Health Research Ethics Board
          will be able to see the information.
        </p>
        <p>
          Your child's data will be collected through a secure online system
          that uses log-ins, encryption, and password protection. It follows
          privacy rules and University of Calgary security requirements. The
          data will be stored safely on a secure Canadian server.
        </p>
        <p>
          We will use study ID numbers instead of names in the database, so no
          one reading the study results will know who your child is. Some online
          surveys may ask for personal information, but this information is not
          linked directly to your child's study data. De-identified data may be
          used in future related studies. We will not look at any of your
          child's medical records outside of what they provide for this study.
        </p>
        <h5 className="lead mt-3">
          HOW LONG WILL INFORMATION FROM THE STUDY BE KEPT?
        </h5>
        <p>
          The researchers intend to keep the research data for approximately{" "}
          <b>10</b> years. Any future use of this research data is required to
          undergo review by a Research Ethics Board.
        </p>
        <h5 className="lead mt-3">
          USE OF DATA [AND/OR BIOSPECIMENS] FOR FUTURE RESEARCH
        </h5>
        <p>
          It is your choice whether or not to let researchers share your child's
          data for research in the future. If you say “yes,” you can change your
          mind later, but your data might still be used if they have already
          been shared.
        </p>
        <h5 className="lead mt-3">CONTACT FOR FUTURE RESEARCH</h5>
        University of Calgary researchers may contact me in the future to ask
        for my child to take part in other research studies.
        <div className="form-check" style={{ marginTop: "1rem" }}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="radio"
              name="agree_to_be_contacted"
              id="agree_to_be_contacted_yes"
              value={true}
              onClick={this.handleChange}
            />
            {translate("quebecCityConsent.t103")}
          </label>
        </div>
        <div className="form-check" style={{ marginBottom: "1rem" }}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="radio"
              name="agree_to_be_contacted"
              id="agree_to_be_contacted_no"
              value={false}
              onClick={this.handleChange}
            />
            {translate("quebecCityConsent.t104")}
          </label>
        </div>
        <h5 className="lead mt-3">
          IF MY CHILD SUFFERS A RESEARCH-RELATED INJURY, WILL WE BE COMPENSATED?
        </h5>
        <p>
          If you think your child was hurt because of this study, it is
          important to tell the researchers. In the event that your child
          suffers injury as a result of participating in this research, no
          compensation will be provided to you or your child by the University
          of Calgary or the Researchers. However, you still have all your legal
          rights. Nothing said in this consent form alters your right, or your
          child's right, to seek damages.
        </p>
        <h5 className="lead mt-3">
          WHO CAN I CONTACT IF I HAVE QUESTIONS ABOUT THIS STUDY?
        </h5>
        <h4 className="lead mt-3">The Research Team:</h4>
        You may contact Shane Esau at 403.220.6336 with any questions or
        concerns about the research or your child's participation in this study.
        <h4 className="lead mt-3">
          Conjoint Health Research Ethics Board (CHREB):{" "}
        </h4>
        If you have any questions concerning your child's rights as a possible
        participant in this research, please contact the Chair, Conjoint Health
        Research Ethics Board, University of Calgary at 403-220-7990 or emaill{" "}
        <span style={{ textDecoration: "underline" }}>
          chreb.chair@ucalgary.ca
        </span>
        <h5 className="lead mt-3">
          HOW CAN I FIND OUT ABOUT THE STUDY RESULTS?
        </h5>
        <p>
          Data and results will be shared through Siksika Health Leadership's
          directives on research dissemination and community reports will be
          regularly provided.
        </p>
        <h5 className="lead mt-3">
          WHAT ARE MY CHILD'S RIGHTS IF THEY TAKE PART IN THIS STUDY?
        </h5>
        <p>
          Your child's participation in this study is a choice. You can choose
          whether or not you want your child to participate. Whatever decision
          you make, there will be no penalty to you or your child.
        </p>
        <ul>
          <li>
            You have a right to have all of your questions answered before
            deciding whether your child will take part.
          </li>
          <li>
            Your decision will not affect the standard medical care your child
            receives or their participation in the tournament.
          </li>
          <li>
            If you decide for your child to take part, they can leave the study
            at any time.
          </li>
          <li>
            Your child may refuse to answer any questions that they do not want
            to answer and still remain in the study.
          </li>
        </ul>
        <h5 className="lead mt-3">
          HOW DO I INDICATE AGREEMENT FOR MY CHILD TO PARTICIPATE?
        </h5>
        Your signature on this form indicates that you have understood to your
        satisfaction the information regarding your child's participation in the
        research project and agree for them to participate as a participant. In
        no way does this waive your or your child's legal rights nor release the
        investigators or involved institutions from their legal and professional
        responsibilities.
        <hr />
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">Name of Child:</label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="child_name"
              name="child_name"
              value={child_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Name of Parent or Legal Guardian:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="parent_name"
              name="parent_name"
              value={parent_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">Witness Name:</label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="witness_name"
              name="witness_name"
              value={witness_name}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className={"form-group row"}>
          <label className="col-lg-4 col-form-label">
            Contact Number of Person Obtaining Consent:
          </label>
          <div className={"col-lg-4 mb-2"}>
            <input
              type="text"
              className="form-control"
              id="consent_phone_number"
              name="consent_phone_number"
              value={consent_phone_number}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <hr />
      </div>
    );
  }
}
